import { render, staticRenderFns } from "./CustomDetailFilter.vue?vue&type=template&id=83fdca4e&"
import script from "./CustomDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./CustomDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports